import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Vue2TouchEvents from 'vue2-touch-events';
import UngerboeckService from '@/services/UngerboeckService';
import ABApiService from '@/services/ABApiService';
import CartService from '@/services/CartService';
import LoggingService from '@/services/LoggingService';
import LoginService from '@/services/LoginService';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import '../assets/styles/rin-swal.less';
import AnnouncementBarService from '@/services/AnnouncementBarService';
import CurrencyService from '@/services/CurrencyService';
import ZApiService from '../services/ZApiService';
import ProductService from '../services/ProductService';
import FApiService from '../services/FApiService';
import FrontpageService from '../services/FrontpageService';
import WpApiService from '../services/WpApiService';
import PartnerApplicationService from '../services/PartnerApplicationService';
import SingleIncentiveService from '../services/SingleIncentiveService';
import ImageService from '@/services/ImageService';
import PartnerService from '@/services/PartnerService';
import ChannelizeService from '@/services/ChannelizeService';
import AuthService from '@/services/AuthService';
import CartApiService from '../services/CartApiService';
import CustomersService from '../services/CustomersService';
import OrdersBackendService from '../services/OrdersBackendService';

Vue.use(Vuelidate);
Vue.use(VueSweetalert2, { buttonsStyling: false });
Vue.use(Vue2TouchEvents);

const abApiService = new ABApiService();
const ordersBackendService = new OrdersBackendService();
const cartApiService = new CartApiService(ordersBackendService);
const fApiService = new FApiService();
const wpApiService = new WpApiService();
const zApiService = new ZApiService();

const announcementBarService = new AnnouncementBarService();
const authService = new AuthService();
const cartService = new CartService(zApiService);
const channelizeService = new ChannelizeService(zApiService);
const currencyService = new CurrencyService(zApiService);
const customersService = new CustomersService(zApiService);
const frontpageService = new FrontpageService(zApiService, fApiService, wpApiService);
const imageService = new ImageService(zApiService);
const loggingService = new LoggingService();
const loginService = new LoginService(zApiService, cartService);
const partnerApplicationService = new PartnerApplicationService(zApiService, abApiService);
const partnerService = new PartnerService(zApiService);
const productService = new ProductService(zApiService);
const singleIncentiveService = new SingleIncentiveService(zApiService);
const ungerboeckService = new UngerboeckService(zApiService);

Vue.prototype.$abApiService = abApiService;
Vue.prototype.$announcementBarService = announcementBarService;
Vue.prototype.$authService = authService;
Vue.prototype.$cartService = cartService;
Vue.prototype.$cartApiService = cartApiService;
Vue.prototype.$channelizeService = channelizeService;
Vue.prototype.$currencyService = currencyService;
Vue.prototype.$customersService = customersService;
Vue.prototype.$fApiService = fApiService;
Vue.prototype.$frontpageService = frontpageService;
Vue.prototype.$imageService = imageService;
Vue.prototype.$loggingService = loggingService;
Vue.prototype.$loginService = loginService;
Vue.prototype.$partnerApplicationService = partnerApplicationService;
Vue.prototype.$partnerService = partnerService;
Vue.prototype.$productService = productService;
Vue.prototype.$singleIncentiveService = singleIncentiveService;
Vue.prototype.$ungerboeckService = ungerboeckService;
Vue.prototype.$wpApiService = wpApiService;
Vue.prototype.$zApiService = zApiService;

export default Vue;
